export const getEnumKey = <T, X>(enumeration: T, value: X): string =>
  Object.keys(enumeration).find(k => value === enumeration[k]);

export function mapEnums<T, X>(
  startEnum: T,
  endEnum: X,
  value?: T[keyof T]
): X[keyof X] {
  if (value) {
    const key: string = getEnumKey(startEnum, value);
    return endEnum[key];
  } else {
    return null;
  }
}
